import { ErrorResponse } from '~shared/models';
import { SearchResponse } from '../../models';

export interface ProductsState {
  payload: SearchResponse;
  loading: boolean;
  error: ErrorResponse;
  currentFilter: { [key: string]: any };
  currentOffset: number;
  currentLimit: number;
}
export const productsInitialState: ProductsState = {
  payload: {
    correction: '',
    products: {
      items: [],
      totalCount: 0,
    },
    recommendedProducts: null,
    metaData: null,
  },
  loading: false,
  error: null,
  currentFilter: {},
  currentOffset: 0,
  currentLimit: 0
};
